export default function AdaptabilityIcon() {
   return (
      <svg
         width="45"
         height="45"
         viewBox="0 0 45 45"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <mask
            id="mask0_5451_24636"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="45"
            height="45"
         >
            <path
               d="M44.6642 0.733185H0.617188V44.7802H44.6642V0.733185Z"
               fill="white"
            />
         </mask>
         <g mask="url(#mask0_5451_24636)">
            <path
               d="M32.868 19.8301L30.2871 15.3599L29.7346 15.6789C27.7272 16.8378 25.218 15.3891 25.218 13.0712V12.4332H20.0562V13.0712C20.0562 15.3891 17.547 16.8378 15.5397 15.6789L14.9872 15.3599L12.4062 19.8301L12.9589 20.1491C14.9662 21.308 14.9662 24.2054 12.9589 25.3643L12.4062 25.6834L14.9872 30.1536L15.5397 29.8345C17.547 28.6756 20.0562 30.1243 20.0562 32.4422V33.0802H25.218V32.4422C25.218 30.1243 27.7272 28.6756 29.7346 29.8345L30.2871 30.1536L32.868 25.6834L32.3154 25.3643C30.3081 24.2054 30.3081 21.308 32.3154 20.1491L32.868 19.8301Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M22.6341 25.7677C24.297 25.7677 25.6452 24.4197 25.6452 22.7567C25.6452 21.0938 24.297 19.7457 22.6341 19.7457C20.9711 19.7457 19.623 21.0938 19.623 22.7567C19.623 24.4197 20.9711 25.7677 22.6341 25.7677Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M34.7695 34.8868H43.3725V43.4898H34.7695V34.8868ZM6.20773 34.8868L1.90625 43.4898H10.5092L6.20773 34.8868Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M6.20773 10.6266C8.58333 10.6266 10.5092 8.70073 10.5092 6.32513C10.5092 3.94941 8.58333 2.02365 6.20773 2.02365C3.83212 2.02365 1.90625 3.94941 1.90625 6.32513C1.90625 8.70073 3.83212 10.6266 6.20773 10.6266Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.35242 29.6391V15.8743M5.35242 15.8743L2.77148 18.4552M5.35242 15.8743L7.93335 18.4552M15.762 5.46486H29.5267M29.5267 5.46486L26.9458 2.88393M29.5267 5.46486L26.9458 8.04568M29.5267 40.0486H15.762M15.762 40.0486L18.3429 37.4678M15.762 40.0486L18.3429 42.6295M39.9362 17.595V29.6391M39.9362 29.6391L42.5172 27.0582M39.9362 29.6391L37.3553 27.0582M43.3775 4.507V9.47404L39.076 11.9574L34.7745 9.47404V4.50712L39.076 2.02365L43.3775 4.507Z"
               stroke="#1F473E"
               strokeWidth="2"
               strokeMiterlimit="10"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </g>
      </svg>
   )
}
